"use client";
import { isTitleCase as s } from "./misc.js";
function p(e, r) {
  if (!s(r)) return e;
  const i = `\\b${r.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}\\b`;
  return new RegExp(`^${i}\\b`, "i").test(e) ? e : e.replace(new RegExp(i, "gi"), r);
}
export {
  p as standardizeOrganizationDisplayName
};
